export default __webpack_public_path__ + "static/media/TVpodnaslovljalnik.4afc08c9.png";